<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>
    <div class="mobileHeader">
      <p>
        <span style="margin-right: 10%">单号：{{ list.relationNumber }}</span>
        <span>到仓日期：{{ list.estimatedDate }}</span>
      </p>
      <span>供应商：{{ list.supplier }}</span>
    </div>

    <van-tabs
      v-model="active"
      line-width="50%"
      line-height="2px"
      color="#29c727"
      @click="tabClick"
    >
      <van-tab title="签收">
        <div class="sign-item">
          <div class="signInDetail-content">
            <p>SKU: {{ list.skuCode }}</p>
            <span style="margin-right: 10%"
              >送货数量：{{ list.deliveryQty }}</span
            ><span>已收货数量：{{ list.receiveQty }}</span>
            <p>名称：{{ list.productNameCN }}</p>
          </div>
          <div class="signInDetail-btnBox">
            <ul>
              <li>
                <span>长CM</span>
                <input
                  type="number"
                  :style="{ color: isReadDevice ? 'red' : '#000' }"
                  class="volume fl"
                  v-model="list.boxLength"
                  @change="inputNumChange('boxLength')"
                  min="0"
                  max="10000"
                />
                <span>宽CM</span>
                <input
                  type="number"
                  :style="{ color: isReadDevice ? 'red' : '#000' }"
                  class="volume fl"
                  v-model="list.boxWidth"
                  @change="inputNumChange('boxWidth')"
                  min="0"
                  max="10000"
                />
                <span>高CM</span>
                <input
                  type="number"
                  :style="{ color: isReadDevice ? 'red' : '#000' }"
                  class="volume fl"
                  v-model="list.boxHeight"
                  @change="inputNumChange('boxHeight')"
                  min="0"
                  max="10000"
                />
              </li>
              <li>
                <span>单箱重量(kg)</span>
                <input
                  type="number"
                  :style="{ color: isReadDevice ? 'red' : '#000' }"
                  class="volume fl"
                  v-model="list.boxWeight"
                  @change="inputNumChange('boxWeight', 3)"
                  min="0"
                  max="10000"
                />
              </li>
              <li>
                <span>单箱数量</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.singleBoxQty"
                  @change="inputParseIntNumChange('singleBoxQty')"
                  min="0"
                  max="10000"
                />
                <span>件数</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.lastCompleteBoxCount"
                  @change="inputParseIntNumChange('lastCompleteBoxCount')"
                  min="0"
                  max="10000"
                />
              </li>
              <li style="display: block">
                <span
                  >{{ list.singleBoxQty }} * {{ list.lastCompleteBoxCount }} =
                  {{ list.singleBoxQty * list.lastCompleteBoxCount }}</span
                >
                <!-- <button
                  class="btn"
                  style="float: right; margin: 6px 6px 0 0"
                  @click="readDevice"
                >
                  读取设备
                </button> -->

                <el-button
            type="success"
            size="small"
            @click="printInfo"
            style="float: right; margin-right: 5px; margin-top: 2px; border-radius: 5px;"
            >打印托唛</el-button
          >
              </li>
              <li>
                <span>尾箱数量</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.lastTailBoxPcsQty"
                  @change="inputParseIntNumChange('lastTailBoxPcsQty')"
                  min="0"
                  max="10000"
                />
                <span>尾箱重量(kg)</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.tailBoxWeight"
                  @input="tailBoxWeightInput"
                  @change="inputNumChange('tailBoxWeight', 3)"
                  min="0"
                  max="10000"
                />
              </li>

              <li>
                <span>托盘</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.palletQty"
                  @change="inputParseIntNumChange('palletQty')"
                  placeholder=""
                />
                <span>X箱数</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.boxQty"
                  @change="inputParseIntNumChange('boxQty')"
                  placeholder=""
                />
                <span>尾托箱</span>
                <input
                  type="number"
                  class="volume fl"
                  v-model="list.tailBoxQty"
                  @change="inputParseIntNumChange('tailBoxQty')"
                  placeholder=""
                />
              </li>
              <li style="display: block">
                <span
                  >本次签收数量：{{
                    Number(list.singleBoxQty * list.lastCompleteBoxCount) +
                    Number(list.lastTailBoxPcsQty)
                  }}</span
                >
                <div style="float: right; margin: 6px 0 0 0">
                  <!-- <van-checkbox v-model="isDischarge" name="isDischarge " shape="square">仓库卸货</van-checkbox> -->
                  <van-radio-group v-model="isDischarge" direction="horizontal">
                    <van-radio
                      name="warehouseUnloading"
                      shape="square"
                      icon-size="14px"
                      >货主自卸</van-radio
                    >
                    <van-radio
                      name="unloadingMethod"
                      shape="square"
                      icon-size="14px"
                      >仓库卸货</van-radio
                    >
                  </van-radio-group>
                </div>

                
              </li>
            </ul>
          </div>
          <button class="signInDetail-receipt" @click="submit">确认收货</button>

        </div>
      </van-tab>
       <van-action-sheet
      v-model="showActionSheetForPrint"
      :actions="actionsForPrint"
      closeable
      :lazy-render="false"
      cancel-text="取消"
      description="请先选择打印机"
      @select="actionSheetSelectForPrint"
    />
      <van-tab title="拍照">
        <div class="sign-photo-cpntent">
          <div class="sign-photo-box">
            <ul>
              <li
                class="sign-photo-item"
                v-for="(item, index) in skuImg"
                :key="index"
              >
                <span class="delete-icon" @click="deleteImg(index)">x</span>
                <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                <img
                  :src="item.base64Url"
                  class="sign-photo-item-img"
                  alt=""
                  @click="previewImage(item.base64Url)"
                />
              </li>

              <li class="sign-photo-btn">
                <div class="photo">
                  <input
                    class="img hidden"
                    @change="changeImg()"
                    type="file"
                    name="cover"
                    ref="inputer"
                    accept="image/*"
                    multiple
                  />
                  <p @click="chooseImage">
                    <i class="el-icon-camera"></i>
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div class="sign-photo-save">
            <button class="signInDetail-receipt" @click="submitImg">
              保存
            </button>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Field,
  Tab,
  Tabs,
  Toast,
  ImagePreview,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Button,
  ActionSheet,
} from "vant";
import util from "util/date";
import {
  getDeliveryNo,
  submitSignFor,
  insertSignForImage,
  getScanData,
} from "@/api/mobile/signIn_api";
import { mixins } from "../mobileMixins";
import { isMobileTerminal } from "util/validate";
import { BaseApiUrl } from "@/api/axios_config";
import { PrintPallet } from "@/api/mobile/bale_api.js";
import axios from "axios";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";
export default {
  data() {
    return {
      list: {},
      active: 0,
      showActionSheetForPrint:false,
      printSuccess:false,
      isSetPrinter:false,
      signForId: 0,
      saveSrcArr: [],
      showActionSheetForPrint: false,
      actionsForPrint: [],
      skuImg: [],
      itemArr: [
        "长",
        "宽",
        "高",
        "单箱重量",
        "单箱数量",
        "件数",
        "尾箱数量",
        "尾箱重量",
      ],
      isReadDevice: false,
      imgFiles: [],
      isDischarge: undefined,
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [ImagePreview.name]: ImagePreview,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [ActionSheet.name]: ActionSheet,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    printInfo() {
       let {
         wareHouseID,
       } = this.list;
      if (this.signForId==0) {
        Toast("请先确认收货再打印");
        return;
      }

      this.toGetPrinterByUser(wareHouseID);
    },
    // 查询用户是否设置打印机123
    toGetPrinterByUser(warehouseID) {
      const data = {
        moduleType: 10, // 箱唛
        wareId: warehouseID,
      };
      this.isSetPrinter = false;
      this.actionsForPrint = [];

      GetPrinterByUser(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200 && response.length) {
          this.showActionSheetForPrint = true;
          Toast("请选择打印机");
          response.forEach((item, i) => {
            this.actionsForPrint.push({
              name: item.printerName,
              id: item.printerInfoID,
            });
            console.log(this.actionsForPrint);
          });
        } else if (status === -100) {
          Toast(msg);
        }
        if (status === 200 && response === 0) {
          this.isSetPrinter = true;
          this.printpalletinfo();
        }
      });
      console.log("显示打印机" + this.isSetPrinter);
    },
    actionSheetSelectForPrint(act, i) {
      this.toAddUserPrinter(act.id);
      this.showActionSheetForPrint = false;
    },
    // 新增打印机
    toAddUserPrinter(id) {
      const data = {
        moduleType: 10, // 打包箱号条码
        printerInfoID: id,
      };
      AddUserPrinter(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200) {
          this.isSetPrinter = true;
          Toast.success(msg || "添加打印机成功");
        } else {
          Toast(msg);
        }
      });
    },
    printpalletinfo() {
      this.printSuccess = false;
      const data = {
        sourceID: this.signForId,
        sourceType: 46,
        wareID: this.list.wareHouseID,
      };
      console.info(data);
      PrintPallet(data).then((res) => {
        Toast.clear();
        if (res.success) {
          this.jsonpPrint(res.response);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    jsonpPrint(url) {
      Toast.loading({
        message: "打印中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      //  console.log('打印机地址是:'+url);

      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          Toast.clear();
          Toast.success("打印成功");
          // 更新状态
          this.printSuccess = true;
        })
        .catch((err) => {
          Toast.fail("打印失败");
          console.log("err", err); //请求失败
          Toast.clear();
          if (err.status === 0) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
            Toast.success("打印成功");
          } else {
            Toast.fail("打印失败");
          }
        });
    },
    init() {
      this.getDeliveryNo();
    },
    getDeliveryNo() {
      const { skuCode, twDeliveryNo } = this.$route.query;
      const data = {
        skuCode,
        deliveryNo: twDeliveryNo,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getDeliveryNo(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.estimatedDate = util.formatDate.format(
              new Date(response.estimatedDate),
              "yyyy-MM-dd"
            );
          } catch {}

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    inputNumChange(field, fix = 1) {
      let num = Number(this.list[field]).toFixed(fix);
      if (num > 10000) {
        Toast("数值最大10000");
        num = Number(10000).toFixed(fix);
      } else if (num < 0) {
        Toast("请输入正数");
        num = Math.abs(num).toFixed(fix);
      }
      this.$set(this.list, field, num);
    },
    inputParseIntNumChange(field) {
      let num = Number(this.list[field]);
      if (num > 10000) {
        Toast("数值最大10000");
        num = 10000;
      } else if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      if (field === "lastTailBoxPcsQty" && num === 0) {
        this.$set(this.list, "tailBoxWeight", "0");
      }
      if (
        field === "lastTailBoxPcsQty" &&
        num >= Number(this.list["singleBoxQty"])
      ) {
        Toast("尾箱数量需小于单箱数量");
        num = 0;
      }
      this.$set(this.list, field, parseInt(num));
    },
    tailBoxWeightInput() {
      if (!this.list.lastTailBoxPcsQty) {
        this.$set(this.list, "tailBoxWeight", "0");
        Toast("请先输入尾箱数量");
      }
    },
    checkParam() {
      const {
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        singleBoxQty,
        lastCompleteBoxCount,
      } = this.list;
      const obj = {
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        singleBoxQty,
        lastCompleteBoxCount,
      };

      const valueArr = Object.values(obj);
      for (let i = 0; i < valueArr.length; i++) {
        const v = valueArr[i];
        if (v === 0 || v === "0.000" || v === "0.0" || !v) {
          this.showsound(false);
          Toast(`请输入${this.itemArr[i]}`);
          return false;
        }
      }
    },
     showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const {
        twDeliveryNo,
        skuCode,
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        singleBoxQty,
        lastCompleteBoxCount,
        lastTailBoxPcsQty,
        tailBoxWeight,
        deliveryQty,
        receiveQty,
        boxQty,
        palletQty,
        tailBoxQty,
      } = this.list;

      const totalQty =
        Number(singleBoxQty * lastCompleteBoxCount) + Number(lastTailBoxPcsQty);

      if (totalQty > deliveryQty - receiveQty) {
        this.showsound(false);
        Toast("签收数量不能大于（送货数量-已收货数量）");
        return;
      }

      const totalBox =
        Number(lastCompleteBoxCount) + (Number(lastTailBoxPcsQty) > 0 ? 1 : 0);
      console.info(totalBox);
      const pallBoxQty = Number(boxQty * palletQty) + Number(tailBoxQty);
      console.info(pallBoxQty);
      if (totalBox != pallBoxQty) {
        this.showsound(false);
        Toast("托盘箱数与签收箱数不一致");
        return;
      }
      if (!this.isDischarge) {
        this.showsound(false);
        Toast("请选择卸货方式");
        return;
      }

      if (this.checkParam() == false) {
        return;
      }

      const data = {
        totalQty:
          Number(singleBoxQty * lastCompleteBoxCount) +
          Number(lastTailBoxPcsQty),
        completeBoxCount: lastCompleteBoxCount,
        tailBoxPcsQty: lastTailBoxPcsQty,
        twDeliveryNo,
        skuCode,
        boxLength,
        boxWidth,
        boxHeight,
        boxWeight,
        tailBoxWeight,
        singleBoxQty,
        isDischarge: this.isDischarge == "unloadingMethod" ? true : false,
        boxQty,
        palletQty,
        tailBoxQty,
      };

      Toast.loading({
        message: "收货中...",
        forbidClick: true,
      });

      submitSignFor(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          this.signForId = res.response;
           this.showsound(true);
          Toast.success("签收成功");

          // setTimeout(function(){
          //     that.$router.go(-1)
          // },1500)
        } else {
           this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
    tabClick(n, t) {
      if (this.signForId===0 && n === 1) {
         this.showsound(false);
        Toast("请先确认收货");
        this.$nextTick(function () {
          this.active = 0;
        });
      }
    },

    readDevice() {
      const data = {
        skuCode: this.list.skuCode,
        areaCode: "",
      };

      Toast.loading({
        message: "读取中...",
        forbidClick: true,
      });
      getScanData(data).then((res) => {
        Toast.clear();

        if (res.status === 200 && res.success) {
          this.isReadDevice = true;
          const { goodLength, goodHeight, goodWeight, goodWidth } =
            res.response;
          this.$set(this.list, "boxLength", goodLength);
          this.$set(this.list, "boxWidth", goodWidth);
          this.$set(this.list, "boxHeight", goodHeight);
          this.$set(this.list, "boxWeight", goodWeight);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    deleteImg(i) {
      this.skuImg.splice(i, 1);
      this.imgFiles.splice(i, 1);
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);
    },

    chooseImage() {
      // if (isMobileTerminal()) {  // 是移动端
      // 	// 调用微信api
      // 	this.$wx.chooseImage({
      // 		count: 9,
      // 		sizeType: ['original', 'compressed'],
      // 		sourceType: ['album', 'camera'],
      // 		success: function (res) {
      // 			// that.skuImg = [...that.skuImg, ...res.localIds]
      // 			// if (this.$store.getters.getPhoneType === 'IOS') {
      // 			// 	that.skuImg.forEach((item, index) => {
      // 			// 		that.getLocalImgData(item, index)
      // 			// 	})
      // 			// }

      // 			const imags = [...that.skuImg, ...res.localIds]
      // 			imags.forEach((item, index) => {
      // 				that.getLocalImgData(item, index)
      // 			})
      // 		}
      // 	})
      // } else {
      // 	document.getElementsByClassName('img')[0].click()
      // }
      document.getElementsByClassName("img")[0].click();
    },

    getLocalImgData(item, index) {
      let that = this;
      this.$wx.getLocalImgData({
        localId: "item",
        success: function (res) {
          that.skuImg[index].base64Url = res.localData;
        },
      });
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        let obj = { name };

        var reader = new FileReader();
        reader.onload = function (e) {
          obj.base64Url = e.target.result;
          srcArr.push(obj);
          that.$set(that.skuImg, that.skuImg.length, obj);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      axios({
        url:
          `${BaseApiUrl}/SignFor/InsertSignForImage?signForID=` +
          that.signForId,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          Toast.success("保存成功");

          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
}
.sign-item {
  background-color: #fbf9fe;
  padding: 10px;
  .signInDetail-content {
    font-size: 15px;
  }
  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }
    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }
  }
}
.signInDetail-receipt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.btn {
  width: 35%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 14px;
  border: 0;
  height: 25px;
  line-height: 25px;
}
.sign-photo-box {
  margin: 5px 10px 10px;
  border: 1px solid #797979;
  box-sizing: border-box;
  padding: 10px;
  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;
      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.sign-photo-save {
  padding: 0 10px;
}
::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fl {
  flex: 1 1 0%;
  max-width: 100% !important;
}
.hidden {
  display: none;
}
@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>